import './index.erb';
import './index.rb';

import './components/activated';
import './components/expired';

class TopBarTrial {
  constructor() {
    this.$context = $('.js-top-bar-trial');
    this.showTopBar();
    this.toggleTopBar();
  }

  toggleTopBar() {
    $('.js-top-bar-trial-close', this.$context).on('click', () => {
      this.$context.hide();

      if (localStorage) {
        localStorage.setItem('closedTopBarTrial', true);
      }
    });
  }

  showTopBar() {
    if (!localStorage) {
      return;
    }

    const isClosedTopBarTrial =
      localStorage.getItem('closedTopBarTrial') === 'true';

    if (isClosedTopBarTrial) {
      this.$context.hide();
    } else {
      this.$context.show();
    }
  }
}

(function () {
  new TopBarTrial();
})();
